<script lang="ts">
  import { gsap } from "gsap";
  import { fade } from "svelte/transition";
  import { createEventDispatcher, onMount } from "svelte";
  import CenterScreen from "../components/CenterScreen.svelte";
  import CountDown from "../components/CountDown.svelte";
  import Intro from "../components/Intro.svelte";
  import { Html, questions } from "../data/surveys/index";
import FormPenguin from "../components/FormPenguin.svelte";
  
  const dispatch = createEventDispatcher<{ complete: void }>();
  
  onMount(() => {
  });

  let show_intro = true;
  let submit_form = false;
  let you_are_the = null;
  let error_message = {};

  function shared() {
    const url = `https://www.facebook.com/dialog/share?
    app_id=365754901520875
    &display=popup
    &href=https%3A%2F%2Fkiamudomalumni.insidethesandbox.studio`.replace(/\s/g, '')
    console.log(url)
    window.open(url, '_blank')
  }

  async function submit_responses(data: any) {
    console.log(data)
    const response = await fetch("https://api.kiamudomalumni.insidethesandbox.studio/responses", {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    return await response.json()
  }

  async function get_summary() {
    const response = await fetch("https://api.kiamudomalumni.insidethesandbox.studio/responses/summary", {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
    })
    return await response.json()
  }

  async function submit(data: any) {
    console.log('submit', data)
    await submit_responses(data)
    submit_form = true;

    const resp = await get_summary()
    you_are_the = resp.length - 200
    console.log('response', resp, 'get summary')
  }

</script>

<!-- MAIN -->
{#if show_intro}
  <Intro on:complete={() => show_intro = false} />
{:else if !submit_form}
  <FormPenguin on:submit={e => submit(e.detail)} />
{:else if submit_form}
  <CenterScreen>
    <div id='thankyou' class="container text-center flex flex-col justify-center items-center pb-8" 
      in:fade={{delay: 700}} out:fade
    >
      <p class='text-sm'>ขอบคุณที่มาร่วมลงชื่อกับเรา</p>
      <p class='text-sm'>คุณเป็นรายชื่อที่ {you_are_the}</p>
      <p class='text-sm mt-2'>เราต้องการอีก {7700 - you_are_the} รายชื่อ</p>
      <p class='text-sm mb-2'>ภายใน</p>
      <CountDown/>
      <p class='text-sm mt-2'>เพื่อยื่นต่อศาล</p>
      <button class='button block mt-8 text-sm is-primary' on:click={shared}>แชร์เว็บนี้ให้พี่น้องเตรียมอุดมของคุณ</button>
    </div>
  </CenterScreen>
{/if}


<!-- PROGRESS BAR -->
<style lang="scss">
  .container {
    @apply px-6;
    @apply mx-auto;
    max-width: 600px;
  }
</style>
